import { TPAComponentProps } from '../../types';

export type DividerProps = TPAComponentProps & {
  /** Change dividers layout value. @Default horizontal */
  direction?: 'horizontal' | 'vertical';
  ariaHidden?: boolean;
};
